import { useSelector } from 'react-redux'
import GalleryLayout from '../../components/common/ui/GalleryLayouts'
import Skeleton from 'react-loading-skeleton'

export default function PhotoGalleryApp(styleProps) {
    const { obituary } = useSelector((state) => state.obituaryReducer)

    const obituaryLayoutSetting = obituary?.settings?.photo_gallery_layout

    const templateName = obituary?.gallery_photos.length >= 9 && obituaryLayoutSetting
        ? obituaryLayoutSetting
        : 'StandardGallery'

    return (
        <>
            {obituary ?
                <GalleryLayout
                    templateName={templateName}
                    obituary={obituary}
                    {...styleProps}
                /> : <Skeleton height={25} count={3} />
            }
        </>
    )
}
